import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import FitnessCenterRoundedIcon from "@mui/icons-material/FitnessCenterRounded";
import ChildCareRoundedIcon from "@mui/icons-material/ChildCareRounded";
import LocalParkingRoundedIcon from "@mui/icons-material/LocalParkingRounded";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import ParkRoundedIcon from "@mui/icons-material/ParkRounded";
import ElevatorRoundedIcon from "@mui/icons-material/ElevatorRounded";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import MosqueRoundedIcon from "@mui/icons-material/MosqueRounded";
import CleaningServicesRoundedIcon from "@mui/icons-material/CleaningServicesRounded";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";



import solarSystem from "../assets/solar-system.png";
import "./Amenities.css";

const amenities = [
  {
    icon: <FitnessCenterRoundedIcon />,
    title: "Fitnes Center",
    desc: "Modern equipment and dedicated space to stay active and refreshed.",
  },
  {
    icon: <ChildCareRoundedIcon />,
    title: "Kids Play Area",
    desc: "A safe and fun environment designed for children to enjoy.",
  },
  {
    icon: <LocalParkingRoundedIcon />,
    title: "Secure Parking",
    desc: "Dedicated parking slots with smooth entry and exit flow.",
  },
  {
    icon: <VideocamRoundedIcon />,
    title: "24/7 Surveillance",
    desc: "Round-the-clock monitoring with controlled access for safety.",
  },
  {
    icon: <ParkRoundedIcon />,
    title: "Rooftop Garden",
    desc: "A peaceful green retreat above the city for relaxation and gatherings.",
  },
  {
    icon: <ElevatorRoundedIcon />,
    title: "High-Speed Elevators",
    desc: "Fast and reliable lifts built for comfort and convenience.",
  },
  {
    icon: <KeyRoundedIcon />,
    title: "Keyless Entrance",
    desc: "Smart access system for secure and hassle-free entry.",
  },
  {
    icon: <MosqueRoundedIcon />,
    title: "Prayer Area",
    desc: "A quiet and dedicated space for daily prayers.",
  },
  {
    icon: <CleaningServicesRoundedIcon />,
    title: "Housekeeping Services",
    desc: "Professional cleaning support for a stress-free lifestyle.",
  },
  {
    icon: <WifiRoundedIcon />,
    title: "High-Speed WiFi",
    desc: "Reliable internet connectivity throughout the building.",
  },
];


const Amenities = () => {
  const { ref, inView } = useInView({ threshold: 0.18, triggerOnce: true });

  return (
    <section className="amen" id="amenities" ref={ref}>
      <div className="amen__container">
        <motion.div
          className="amen__head"
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="amen__kicker">AMENITIES</div>
          <h2 className="amen__title">
            Every detail is designed to elevate your day.
          </h2>
          <p className="amen__sub">
            From wellness to work, everything is built to feel effortless —
            clean, calm, and premium.
          </p>
        </motion.div>

        <div className="amen__grid">
          {/* Featured card */}
          <motion.div
            className="amen__featured"
            initial={{ opacity: 0, y: 14 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.06 }}
          >
            <div className="amen__featuredTag">Featured</div>
            <h3 className="amen__featuredTitle">
              {" "}
              Advanced Solar Power Backup System
            </h3>
            <p className="amen__featuredDesc">
              HB Height is equipped with a modern solar energy system that
              provides reliable electricity backup for both residential and
              commercial units. Enjoy reduced power outages, lower electricity
              costs, and uninterrupted comfort for your home or business.
            </p>

            <div className="amen__featuredMedia">
              <img src={solarSystem} alt="Sky lounge" loading="lazy" />
            </div>
          </motion.div>

          {/* Amenities list */}
          <motion.div
            className="amen__cards"
            initial={{ opacity: 0, y: 14 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.12 }}
          >
            {amenities.map((a, idx) => (
              <motion.div
                className="amen__card"
                key={idx}
                initial={{ opacity: 0, y: 10 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.55, delay: 0.04 * idx }}
              >
                <div className="amen__icon">{a.icon}</div>
                <div className="amen__text">
                  <h4 className="amen__cardTitle">{a.title}</h4>
                  <p className="amen__cardDesc">{a.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Amenities;
